/* Meetings: device capture with live transcript, notes and action items, the meeting bot, file
   transcription, and the audio overview / podcast studio. API: api/src/modules/meetings/README.md. */
import { lazy } from 'react';
import { NotebookPen } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'meetings',
  title: 'Meetings',
  icon: NotebookPen,
  group: 'Apps',
  route: '/meetings',
  order: 60,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'record', title: 'Record a meeting', to: '/meetings?record=1', keywords: ['meeting', 'notes', 'transcribe', 'microphone'] },
    { id: 'transcribe', title: 'Transcribe an audio file', to: '/meetings/transcribe', keywords: ['audio', 'video', 'transcript', 'upload'] },
    { id: 'overview', title: 'New audio overview', to: '/meetings/studio', keywords: ['podcast', 'overview', 'narrate'] },
    { id: 'scribe', title: 'Import a recording from Scribe', to: '/meetings?import=1', keywords: ['scribe', 'import', 'recording', 'transcript'] },
    { id: 'bot', title: 'Meeting bot settings', to: '/meetings?bot=1', keywords: ['zoom', 'meet', 'teams', 'bot'] },
  ],
  capabilities: ['OFFICE-07', 'VOICE-07', 'MEDIA-06', 'OFFICE-17'],
});
